import { defineComponent as k, useSlots as b, computed as S, openBlock as i, createBlock as c, unref as o, mergeProps as $, createSlots as T, withCtx as a, renderSlot as f, createElementVNode as l, createElementBlock as s, createVNode as B, resolveDynamicComponent as p, createCommentVNode as d, toDisplayString as u, Fragment as x, createTextVNode as y } from "vue";
import "./ghl-ui.es22.js";
import "./ghl-ui.es166.js";
import N from "./ghl-ui.es167.js";
import D from "./ghl-ui.es168.js";
import g from "./ghl-ui.es69.js";
const I = { class: "hl-drawer-header-container" }, V = {
  key: 0,
  class: "hl-drawer-header-icon"
}, F = {
  key: 0,
  class: "hl-drawer-title"
}, L = {
  key: 1,
  class: "hl-drawer-description"
}, R = { class: "hl-drawer-actions" }, U = { class: "hl-drawer-action-left" }, E = { class: "hl-drawer-action-right" }, q = k({
  name: "UIDrawerContent",
  inheritAttrs: !1
}), A = k({
  ...q,
  props: {
    id: {
      type: String,
      required: !0
    },
    title: {
      type: String,
      default: void 0
    },
    description: {
      type: String,
      default: void 0
    },
    icon: {
      type: Function,
      default: void 0
    },
    width: {
      type: Number,
      default: 502
    },
    positiveText: {
      type: String,
      default: void 0
    },
    negativeText: {
      type: String,
      default: void 0
    },
    loading: {
      type: Boolean,
      default: !1
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    closable: {
      type: Boolean,
      default: !0
    }
  },
  emits: ["negativeClick", "positiveClick"],
  setup(e) {
    const v = e, t = b(), w = S(() => v.positiveText || v.negativeText || (t == null ? void 0 : t.actionLeft) || (t == null ? void 0 : t.actionRight));
    return (n, r) => (i(), c(o(N), $(n.$attrs, {
      closable: e.closable,
      class: "hl-drawer-content"
    }), T({
      default: a(() => [
        f(n.$slots, "default")
      ]),
      _: 2
    }, [
      e.title || e.description || e.icon ? {
        name: "header",
        fn: a(() => [
          l("div", I, [
            e.icon ? (i(), s("div", V, [
              B(o(D), null, {
                default: a(() => [
                  (i(), c(p(e.icon), { class: "w-5 h-5" }))
                ]),
                _: 1
              })
            ])) : d("", !0),
            l("div", null, [
              e.title ? (i(), s("div", F, u(e.title), 1)) : d("", !0),
              e.description ? (i(), s("div", L, u(e.description), 1)) : d("", !0)
            ])
          ])
        ]),
        key: "0"
      } : void 0,
      w.value ? {
        name: "footer",
        fn: a(() => {
          var m, h;
          return [
            l("div", R, [
              l("div", U, [
                (m = o(t)) != null && m.actionLeft ? f(n.$slots, "actionLeft", { key: 0 }) : d("", !0)
              ]),
              l("div", E, [
                (h = o(t)) != null && h.actionRight ? f(n.$slots, "actionRight", { key: 0 }) : (i(), s(x, { key: 1 }, [
                  e.negativeText ? (i(), c(o(g), {
                    key: 0,
                    id: `${e.id}-btn-negative-action`,
                    onClick: r[0] || (r[0] = (C) => n.$emit("negativeClick"))
                  }, {
                    default: a(() => [
                      y(u(e.negativeText), 1)
                    ]),
                    _: 1
                  }, 8, ["id"])) : d("", !0),
                  e.positiveText ? (i(), c(o(g), {
                    key: 1,
                    id: `${e.id}-btn-positive-action`,
                    loading: e.loading,
                    disabled: e.disabled,
                    type: "primary",
                    onClick: r[1] || (r[1] = (C) => n.$emit("positiveClick"))
                  }, {
                    default: a(() => [
                      y(u(e.positiveText), 1)
                    ]),
                    _: 1
                  }, 8, ["id", "loading", "disabled"])) : d("", !0)
                ], 64))
              ])
            ])
          ];
        }),
        key: "1"
      } : void 0
    ]), 1040, ["closable"]));
  }
}), K = A;
export {
  K as default
};
